<template>
  <div class="rules-wrapper">
    <div class="header-section">
      <h2 class="main-title">PRAVIDLA SOUTĚŽE</h2>
      <div class="separator"></div>
    </div>

    <div class="rules-grid">
      <div v-for="(section, index) in rules" :key="index" class="rule-card">
        <div class="card-header">
          <span class="rule-number">{{ index + 1 }}</span>
          <h3 class="rule-title">
            {{ section.title.replace(/^\d+\.\s*/, "") }}
          </h3>
        </div>
        <div class="card-body">
          <div v-html="section.content" class="rules-content"></div>
        </div>
      </div>
    </div>

    <div class="scoring-section mt-5">
      <h3 class="section-title text-red text-center mb-4">BODOVÁNÍ</h3>
      <div class="table-responsive">
        <table class="custom-table">
          <thead>
            <tr>
              <th>TYP VÝSLEDKU</th>
              <th class="text-end">BODY</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(score, index) in scores" :key="index">
              <td>{{ score.result }}</td>
              <td class="text-end font-bold text-red">{{ score.points }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p class="footer-msg">
      Přejeme hodně štěstí a příjemnou zábavu při tipování!
    </p>
  </div>
</template>

<script>
export default {
  name: "GamesRules",
  data() {
    return {
      rules: [
        {
          title: "1. Úvod",
          content:
            "<p>Vítejte v naší komunitní tipovací soutěži! Cílem je předpovídat výsledky fotbalových zápasů a získat co nejvíce bodů. Hra je zcela bez monetizace – jde čistě o zábavu.</p>",
        },
        {
          title: "2. Registrace a přihlášení",
          content: `<ul>
                      <li><strong>Registrace:</strong> Každý nový uživatel začíná s rolí <em>user</em>.</li>
                      <li><strong>Přihlášení:</strong> Nutné pro zadávání tipů.</li>
                      <li><strong>Administrátor:</strong> Spravuje zápasy a vyhodnocení.</li>
                    </ul>`,
        },
        {
          title: "3. Pravidla tipování",
          content: `<ul>
                      <li>Každé kolo obsahuje sadu zápasů a <strong>1 doplňující otázku</strong>.</li>
                      <li>Tipujete přesný počet gólů (domácí vs. hosté).</li>
                      <li>Odpověď na otázku je formou <strong>ANO / NE</strong>.</li>
                      <li><strong>Uzávěrka:</strong> Tipy lze měnit pouze do výkopu zápasu.</li>
                    </ul>`,
        },
        {
          title: "4. Použití Jokera",
          content: `<p>Každý hráč má <strong>jednoho Jokera</strong> na celou soutěž.</p>
                    <ul>
                      <li>Násobí body za celé kolo <strong>2×</strong>.</li>
                      <li>Po použití již nelze vrátit zpět.</li>
                    </ul>`,
        },
        {
          title: "5. Výsledky",
          content: `<p>Systém automaticky spočítá body po zadání výsledků adminem. Své statistiky najdete v sekci <strong>Můj účet</strong>.</p>`,
        },
      ],
      scores: [
        { result: "Přesný tip výsledku (např. 2:1)", points: 10 },
        { result: "Remíza", points: 7 },
        { result: "Správný vítěz + přesné góly jednoho týmu", points: 7 },
        { result: "Správný tip vítěze zápasu", points: 3 },
        { result: "Správná odpověď na bonusovou otázku", points: 5 },
      ],
    };
  },
};
</script>

<style scoped>
/* ========================
   STYLY (Dark Mode)
   ======================== */

.rules-wrapper {
  color: #e0e0e0;
  font-family: "Roboto", sans-serif;
  padding: 20px;
  max-width: 900px;
  margin: 0 auto;
}

/* Nadpis */
.header-section {
  text-align: center;
  margin-bottom: 3rem;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.separator {
  width: 80px;
  height: 4px;
  background-color: #dc3545; /* Červený akcent */
  margin: 0 auto;
  border-radius: 2px;
}

/* Grid pro karty pravidel */
.rules-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

@media (min-width: 768px) {
  .rules-grid {
    grid-template-columns: repeat(
      2,
      1fr
    ); /* Dva sloupce na větších obrazovkách */
  }
}

/* Karty pravidel */
.rule-card {
  background: #111; /* Velmi tmavá šedá */
  border: 1px solid #333;
  border-radius: 12px;
  padding: 25px;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s ease, border-color 0.3s ease;
}

.rule-card:hover {
  border-color: #555;
  transform: translateY(-5px);
}

/* Červený proužek nahoře na kartě */
.rule-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #dc3545, #a71d2a);
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.rule-number {
  font-size: 1.5rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.1); /* Jemné číslo na pozadí */
  margin-right: 15px;
  line-height: 1;
  font-family: "Impact", sans-serif;
}

.rule-card:hover .rule-number {
  color: #dc3545; /* Při najetí zčervená */
  opacity: 1;
}

.rule-title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  margin: 0;
}

/* Obsah pravidel (v-html) */
.rules-content {
  font-size: 0.95rem;
  color: #bbb;
  line-height: 1.6;
}

/* Stylování vnořeného HTML obsahu */
::v-deep ul {
  padding-left: 20px;
  margin-top: 10px;
}

::v-deep li {
  margin-bottom: 8px;
  list-style-type: square;
}

::v-deep strong {
  color: #fff;
}

/* Sekce Bodování - Tabulka */
.scoring-section {
  background: #1a1a1a;
  border: 1px solid #333;
  border-radius: 12px;
  padding: 30px;
  margin-top: 40px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
}

.text-red {
  color: #dc3545;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  color: #ddd;
}

.custom-table th {
  text-transform: uppercase;
  font-size: 0.85rem;
  letter-spacing: 1px;
  color: #888;
  padding: 15px;
  border-bottom: 2px solid #333;
  text-align: left;
}

.custom-table td {
  padding: 15px;
  border-bottom: 1px solid #222;
  font-size: 1rem;
}

.custom-table tr:last-child td {
  border-bottom: none;
}

.text-end {
  text-align: right;
}

.font-bold {
  font-weight: bold;
}

/* Patička */
.footer-msg {
  text-align: center;
  margin-top: 40px;
  font-size: 1.1rem;
  font-weight: bold;
  color: #fff;
  font-style: italic;
  opacity: 0.8;
}
</style>
